import { Component, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IbCModalService } from 'ib-web-commons/ib-modal';
import { AJSRootScope, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { IbDisruptedSeatsModel } from '../../../core/models/disrupted-seats/ib-disrupted-seats-model';

@Component({
    selector: 'ib-disrupted-seats',
    templateUrl: './ib-disrupted-seats.component.html',
    styleUrls: ['./ib-disrupted-seats.component.scss']
})
export class IbDisruptedSeatsComponent implements OnInit {

    @Input() model: IbDisruptedSeatsModel;
    @Input() flowId: string;
    @Input() creationDate: string;
    imgUrl: string = this.$rootScope.routes.images;
    iconUrl: string = this.$rootScope.routes.icons;
    headerModel: GenericHeader;
    boxInfoModels: IbBoxInfoModel[] = [];

    constructor (
        @Inject(AJSRootScope) private $rootScope: any,
        private activeModal: NgbActiveModal,
        private commonsModalService: IbCModalService,
        private commonsSessionStorageService: CommonsSessionStorageService
    ) {
    }


    ngOnInit (): void {
        this.initTextModels();
    }

    openSeatMapDisruptedSegment (disruptedSegmentId: string): void {
        this.commonsSessionStorageService.set('newSeatsMap', true);
        this.$rootScope.$broadcast('openSeatMap', disruptedSegmentId);
        this.activeModal.close();
    }

    goBackMMB (): void {
        const genericModalObject = {
            title: 'SEATS_DISRUPTION_BACK_TO_MMB_TITLE',
            body: 'SEATS_DISRUPTION_BACK_TO_MMB_DESCRIPTION',
            showCancelButton: true
        };
        this.commonsModalService.showGenericModal(genericModalObject).result.then(
            () => {
                this.activeModal.close();
            },
            () => {}
        );
    }

    private initTextModels (): void {
        this.headerModel = {
            title: 'SEATS_DISRUPTION',
            closeText:'CANCEL_SPECIAL_NEEDS_MODAL_CHECK_TEXT_2_TITLE'
        };

        const boxInfo1: IbBoxInfoModel = {
            title: 'MMB_DISRUPTION_CALLCENTER_DOUBTS',
            text: 'MMB_DISRUPTION_CALLCENTER_CONTACT_MSG_NO_PHONE'
        };

        this.boxInfoModels.push(boxInfo1);

        const boxInfo2: IbBoxInfoModel = {
            title: 'MMB_REFUNDS_PASSENGER_RIGHTS_TITLE',
            linkText: 'MORE_INFO_LINK'
        };
        this.boxInfoModels.push(boxInfo2);
    }

}
